class EnumService {
  getYesNo(t) {
    return [
      { label: t('common.yes'), value: true },
      { label: t('common.no'), value: false },
    ];
  }
  getOkNok(t) {
    return [
      { label: t('common.ok'), value: true },
      { label: t('common.nok'), value: false },
    ];
  }

  getPropertyImportTypes(t) {
    return [
      { label: t('propertyImports.creation'), value: true },
      { label: t('propertyImports.deletion'), value: false },
    ];
  }
}

const enumService = new EnumService();
export default enumService;
